import type { MindCard, MindCardType } from '../types';
import { Mascot, type MascotId } from './mascots';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import { CollapsibleItems, DetailDisclosure, ExpandableText } from './Expandable';
import styles from '../App.module.css';

interface MindCardsProps {
  cards: MindCard[];
}

const typeMascot: Record<MindCardType, MascotId> = {
  mind: 'heart',
  body: 'haha',
  life: 'sleep',
  partner: 'papa',
};

function fallbackDetail(body: string, locale: string): string {
  if (locale === 'en') {
    return `${body} If you feel stuck, ask your clinic or local maternal health desk. In Niigata City, parenting support and consultation windows can help.`;
  }
  if (locale === 'zh') {
    return `${body} 如果感到为难，可咨询产院或当地母子保健窗口。在新潟市也可利用育儿支援相关咨询。`;
  }
  return `${body} うまくいかないときは、かかりつけ産院や市区町村の母子保健・子育て相談窓口に聞いて大丈夫です（新潟市の例）。今日はできることをひとつだけで十分です。`;
}

export function MindCards({ cards }: MindCardsProps) {
  const { locale } = useLanguage();
  const ui = getUi(locale);

  return (
    <CollapsibleItems total={cards.length} initial={3}>
      {(visible) => (
        <div className={styles.cards}>
          {cards.slice(0, visible).map((card) => (
            <div
              key={card.id}
              className={`${styles.card} ${styles[`card${card.type.charAt(0).toUpperCase() + card.type.slice(1)}`]}`}
            >
              <span className={styles.cardMascot}>
                <Mascot id={typeMascot[card.type]} size={36} />
              </span>
              <span className={styles.cardType}>{ui.mindCards.typeLabels[card.type]}</span>
              <h4 className={styles.cardTitle}>{card.title}</h4>
              <ExpandableText text={card.body} limit={56} className={styles.cardDesc} />
              <DetailDisclosure detail={card.detail || fallbackDetail(card.body, locale)} />
            </div>
          ))}
        </div>
      )}
    </CollapsibleItems>
  );
}
